import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import React, {useEffect} from "react";
import CCOHeadline from "../fundamentals/CCOHeadline";
import CCOContainer from "../fundamentals/CCOContainer";
import {SosThemeProvider, useThemeContext} from "../../theming/ThemeContext";
import NextLink from "next/link";
import {PORTAL_HP_URL} from "../../common/constants/routes";
import {useTheme} from '@mui/material/styles';
import Navigation from "../layouts/navigation/Navigation";
import TopNavi from "../layouts/topnavi/TopNavi";
import Footer from "../layouts/footer/Footer";
import useWindowSize from "../../utility/useWindowSize";
import {PageGridPlacementType} from "../types";
import {pageGridItemFullWidthSx, pageHeaderSx, placement_footer, placement_header} from "./pageLayoutsUtils";

import type {CAEGlobalSettings} from "../../types/CAEGlobalSettings";

interface Props {
    statusCode: number,
    rootUrl?: string,
    navigation?: any,
    page?: any,
    CAEGlobalSettings?: CAEGlobalSettings | null
}

function ErrorPage(props: Props) {
    const theme = useTheme();
    const themeContext = useThemeContext();
    const {greaterThanWindowLarge} = useWindowSize();
    const h1 = "Fehler - " + props.statusCode;
    const url = props.rootUrl ? props.rootUrl : PORTAL_HP_URL;

    useEffect(() => {
        const rootCtx = url.replaceAll('/', '');
        themeContext.setTheme(rootCtx);
    }, [url, themeContext]);

    const header = props.page?.grid?.placements?.find((p: PageGridPlacementType) => p.name === placement_header);
    const footer = props.page?.grid?.placements?.find((p: PageGridPlacementType) => p.name === placement_footer);

    const colorContainer = theme.palette.primary.light;
    const linkColor = theme.palette.primary.main;
    return <SosThemeProvider>
        {props.navigation &&
         <Box component="header" sx={pageHeaderSx}>
             {greaterThanWindowLarge &&
              <TopNavi navigation={props.navigation} page={props.page} header={header}/>}
             <Navigation navigation={props.navigation} page={props.page} header={header}/>
         </Box>}
        <Box component="main" sx={pageGridItemFullWidthSx}>
            <CCOContainer dataCypress={'errorContainer'} background={colorContainer}>
                <Card variant="outlined">
                    <CardContent>
                        <CCOHeadline headline={h1} type={"h1"} justify={"left"}/>
                        {props.statusCode === 404 ?
                            <Typography>HTTP {props.statusCode} - Die Seite konnte nicht gefunden
                                werden</Typography> :
                            <Typography>HTTP {props.statusCode} - Da hat etwas nicht
                                funktioniert</Typography>}
                        <NextLink id={"link-error-back-to-hp"} shallow={false} href={url}
                                  prefetch={false}>
                            <Typography sx={{color: linkColor}}>Zurück zur Startseite</Typography>
                        </NextLink>
                    </CardContent>
                </Card>
            </CCOContainer>
        </Box>
        {footer && props.CAEGlobalSettings &&
         <Footer items={footer.items} CAEGlobalSettings={props.CAEGlobalSettings} page={props.page}/>}
    </SosThemeProvider>
}


export default ErrorPage
